import { Enums } from "./enums";

export const Links = {
    Url(o, args) {
        if (o) {
            if (o._route) { return "/"; }
            if (o.path) {
                let path = "/" + o.path;
                if (args != null) {
                    if (!Array.isArray(args)) {
                        args = [args];
                    }
                    for (let i = 0; i < args.length; i++) {
                        try {
                            path = path.replaceAll("{" + i + "}", args[i].toString());
                        } catch (e) {
                            console.error(e);
                        }
                    }
                }
                // Geçersiz argsları kaldır.
                path = path.replace(/\{\d+\}\//g, "0").replace(/\{[^\}]*\}/g, "0")
                return path;
            }
        }
        console.error("Geçersiz link:" + o);
    },
    GetMenu(text, icon, o) {
        if (o) {
            if (Array.isArray(o)) {
                return { text: text, class: "" + icon, child: o };
            }
            let args = [];
            for (let i = 3; i < arguments.length; i++) {
                args.push(arguments[i]);
            }
            return { text: text, class: "" + icon, link: Links.Url(o, args), };
        }
        console.error("Geçersiz link:" + o);
    },
    Dashboard: {
        path: "panel",
        component: "DashboardView",
        title: "Anasayfa",
        theme: Enums.THEME.CLASSIC,
        leftSidebar: Enums.MENU_TYPE.MAIN,
    },
    Login: {
        path: "login",
        component: "user/LoginView",
        title: "Giriş",
        theme: Enums.THEME.EMPTY,
    },
    User: {
        Login: {
            path: "login",
            component: "user/LoginView",
            title: "Giriş",
            theme: Enums.THEME.EMPTY,
        },
        Signup: {
            path: "signup",
            component: "user/SignupView",
            title: "Kayıt Ol",
            theme: Enums.THEME.EMPTY,
        },
        ForgotPassword: {
            path: "forgot-password",
            component: "user/ForgotPasswordView",
            title: "Parolamı Unuttum",
            theme: Enums.THEME.EMPTY
        },
        ResetPassword: {
            path: "reset-password",
            component: "user/ResetPasswordView",
            title: "Parola Yenile",
            theme: Enums.THEME.EMPTY
        },
        VerifyPhoneNumber: {
            path: "verify-phone-number",
            component: "user/VerifyPhoneNumberView",
            title: "Telefon Numarası Doğrulama",
            theme: Enums.THEME.EMPTY
        },
        Profile: {
            path: "user/profile",
            component: "user/ProfileView",
            title: "Profilim",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.MAIN,
        },
        Detail: {
            path: "user/profile?p=detail",
            component: "user/ProfileView",
            title: "Kişisel Bilgilerim",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.MAIN,
        },
        Message: {
            path: "user/message",
            component: "user/MessageView",
            title: "Mesajlarım",
            theme: Enums.THEME.CLASSIC,

        },
        Notification: {
            path: "user/profile?p=notification",
            component: "user/ProfileView",
            title: "Bildirimlerim",
            theme: Enums.THEME.CLASSIC,
        },
        Contact: {
            path: "user/profile?p=contact",
            component: "user/ProfileView",
            title: "Bize Ulaşın",
            theme: Enums.THEME.CLASSIC,
        },
        Contract: {
            path: "user/profile?p=contract",
            component: "user/ProfileView",
            title: "Sözleşmelerim",
            theme: Enums.THEME.CLASSIC,
        },
    },
    Appointment: {
        List: {
            path: "appointment/list",
            component: "appointment/ListView",
            title: "Randevularım",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.MAIN,
        },
        Meeting: {
            path: "meeting",
            component: "appointment/MeetingView",
            title: "Görüşme",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.MAIN,
        },
    },
    //Education: {
    //    List: {
    //        path: "education/list",
    //        component: "education/ListView",
    //        title: "Eğitimlerim",
    //        theme: Enums.THEME.CLASSIC,
    //        leftSidebar: Enums.MENU_TYPE.PLAN,
    //    },
    //},
    LiveEducation: {
        List: {
            path: "live-education/list",
            component: "live-education/ListView",
            title: "Ders Al",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.LIVE_EDUCATION,
        },
        PlanList: {
            path: "live-education/plan-list",
            component: "live-education/PlanListView",
            title: "Planlı Ders",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.LIVE_EDUCATION,
        },
        HistoryList: {
            path: "live-education/history-list",
            component: "_partials/student-package/live-education/HistoryListView",
            title: "Geçmiş Dersler",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.LIVE_EDUCATION,
        },
        HistoryDetail: {
            props: [":id"],
            path: "live-education/history-detail/{0}",
            component: "_partials/student-package/live-education/HistoryDetailView",
            title: "Geçmiş Ders Detayı",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.LIVE_EDUCATION,
        },
    },
    Resource: {
        List: {
            props: [":type"],  //Konu Anlatım, Soru Bankası, Deneme
            path: "resource/list/{0}",
            component: "resource/ListView",
            title: "Kaynaklarım",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.RESOURCE,
        },
    },
    Document: {
        PrivateList: {
            props: [":type"],
            path: "document/private-list/{0}",
            component: "document/PrivateListView",
            title: "Özel Dokümanlarım",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.DOCUMENT,
        },
        PublicList: {
            path: "document/public-list",
            component: "document/PublicListView",
            title: "Genel Dokümanlarım",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.DOCUMENT,
        },
        SharedList: {
            path: "document/shared-list",
            component: "document/SharedListView",
            title: "Genel Dokümanlarım",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.DOCUMENT,
        },
        TestList: {
            path: "document/test-list",
            component: "document/TestListView",
            title: "Testler",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.DOCUMENT,
        },
        QuestionList: {
            path: "document/question-list",
            component: "document/QuestionListView",
            title: "Soru Havuzum",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.DOCUMENT,
        },
    },
    Plan: {
        WeeklyList: {
            path: "plan/weekly-list",
            component: "plan/WeeklyListView",
            title: "Haftalık Planım",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.PLAN,
        },
        DailyList: {
            path: "plan/daily-list",
            component: "plan/DailyListView",
            title: "Günlük Planım",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.PLAN,
        },
        DailyList2: {
            path: "plan/daily-list-2",
            component: "plan/DailyList2View",
            title: "Günlük Planım 2",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.PLAN,
        },
        LessonList: {
            props: [":lesson"],
            path: "plan/lesson-list/{0}",
            component: "plan/LessonListView",
            title: "Derslerim",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.PLAN,
        },
        Analysis: {
            path: "plan/analysis",
            component: "plan/AnalysisView",
            title: "İlişkisel Analiz",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.PLAN,
        },
    },
    Student: {
        List: {
            path: "student/list",
            component: "student/ListView",
            title: "Öğrenciler",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.PLAN,
        },
        Card: {
            props: [":id"],
            path: "student/card/{0}",
            component: "student/CardView",
            title: "Öğrencim",
            theme: Enums.THEME.CLASSIC,
            leftSidebar: Enums.MENU_TYPE.SUB_MAIN,
        },
        Resource: {
            List: {
                props: [":id", ":type"],  //Konu Anlatım, Soru Bankası, Deneme
                path: "student/resource/list/{0}/{1}",
                component: "student/resource/ListView",
                title: "Kaynakları",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_RESOURCE,
            },
        },
        Document: {
            PrivateList: {
                props: [":id"],
                path: "student/document/private-list/{0}",
                component: "student/document/PrivateListView",
                title: "Özel Dokümanlarım",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_DOCUMENT,
            },
            PublicList: {
                props: [":id"],
                path: "student/document/public-list/{0}",
                component: "student/document/PublicListView",
                title: "Genel Dokümanlarım",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_DOCUMENT,
            },
            TestList: {
                props: [":id"],
                path: "student/document/test-list/{0}",
                component: "student/document/TestListView",
                title: "Testler",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_DOCUMENT,
            },
            QuestionList: {
                props: [":id"],
                path: "student/document/question-list/{0}",
                component: "student/document/QuestionListView",
                title: "Soru Havuzum",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_DOCUMENT,
            },
        },
        Plan: {
            WeeklyList: {
                props: [":id"],
                path: "student/plan/weekly-list/{0}",
                component: "student/plan/WeeklyListView",
                title: "Haftalık Planım",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_PLAN,
            },
            DailyList: {
                props: [":id"],
                path: "student/plan/daily-list/{0}",
                component: "student/plan/DailyListView",
                title: "Günlük Planım",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_PLAN,
            },
            LessonList: {
                props: [":id", ":lesson"],
                path: "student/plan/lesson-list/{0}/{1}",
                component: "student/plan/LessonListView",
                title: "Derslerim",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_PLAN,
            },
            Analysis: {
                props: [":id"],
                path: "student/plan/analysis/{0}",
                component: "student/plan/AnalysisView",
                title: "İlişkisel Analiz",
                theme: Enums.THEME.CLASSIC,
                leftSidebar: Enums.MENU_TYPE.SUB_PLAN,
            },
        },
    },
};